// TermsPage.js
import React from 'react';
import { Link } from 'react-router-dom';
import './TermsPage.css';

const TermsPage = () => {
  return (
    <div className="simple-terms-page">
      {/* Header */}
      <div className="simple-header">
        <Link to="/" className="simple-logo">
          <span className="simple-logo-icon">🏠</span>
          <span>HomeManager</span>
        </Link>
        <Link to="/" className="simple-back-btn">← Back to Home</Link>
      </div>

      {/* Title */}
      <div className="simple-title-section">
        <h1>Terms & Conditions</h1>
        <p>Last Updated: 21 January 2026</p>
        <p>

These Terms and Conditions ("Terms") govern your access to and use of the Home Manager mobile application ("App") operated by Xigen Technologies ("we," "us," or "our"). By downloading, accessing, or using the App, you agree to be bound by these Terms. If you do not agree, you may not use the App.

        </p>
      </div>

      {/* Content */}
      <div className="simple-content">
        <div className="simple-section">
          <h2>1. Eligibility</h2>
          <p>You must be at least 18 years old to create an account and use Home Manager. By using the App, you confirm that you meet this requirement and that all information you provide is accurate, complete, and truthful.</p>
        </div>

        <div className="simple-section">
          <h2>2. Description of Service</h2>
          <p>Home Manager is a digital platform that connects employers, service professionals, and service agencies. We are a technology service provider, not an employer, employment agency, or party to any agreements between users. We facilitate connections but do not guarantee outcomes, quality, or safety of services rendered.</p>
        </div>

        <div className="simple-section">
          <h2>3. Account Registration & Security</h2>
          <p>Users create accounts using email and password authentication. You agree to:</p>
          <ul>
            <li>Provide accurate and complete information during registration</li>
            <li>Keep your login credentials confidential and secure</li>
            <li>Notify us immediately at info@xigentechnologies.com of any unauthorized access</li>
          </ul>
          <p>You are solely responsible for all activities conducted under your account.</p>
        </div>

        <div className="simple-section">
          <h2>4. Identity Verification</h2>
          <p>For safety and trust purposes, service professionals and agencies may be required to submit personal details and identification documents ("Personal ID"). This may include government-issued ID, passport, or other verification documents. Failure to provide accurate verification information may result in account suspension or termination.</p>
        </div>

        <div className="simple-section">
          <h2>5. User Responsibilities</h2>
          <p>Users agree not to:</p>
          <ul>
            <li>Engage in fraudulent, illegal, or harmful activities</li>
            <li>Upload false, misleading, or defamatory information</li>
            <li>Harass, abuse, or threaten other users</li>
            <li>Misuse the platform or attempt to circumvent its security features</li>
            <li>Violate any applicable laws or regulations</li>
          </ul>
          <p>Violation of these rules may lead to permanent account suspension without refund.</p>
        </div>

        <div className="simple-section">
          <h2>6. Finder's Fees, Payments & Refund Policy</h2>
          <p><strong>a) Finder's Fees:</strong> Certain actions on the platform require payment of a finder's fee as disclosed before the transaction.</p>
          <p><strong>b) Payment Processing:</strong> All payments are securely processed by Flutterwave, our third-party payment provider. Home Manager does not store, process, or have access to your card, bank account, or mobile money credentials.</p>
          <p><strong>c) Refund Policy:</strong> Finder's fees are generally non-refundable once a successful service connection has been facilitated. However, refunds may be issued in certain circumstances.</p>
        </div>

        <div className="simple-section">
          <h2>7. Shop & Marketplace</h2>
          <p>Home Manager provides a marketplace for household products offered by third-party vendors. We are not responsible for product quality, delivery delays, or vendor fulfillment issues.</p>
        </div>

        <div className="simple-section">
          <h2>8. Reviews & Ratings</h2>
          <p>Users may submit reviews and ratings. Content must be truthful, respectful, and based on actual experience. Home Manager reserves the right to remove inappropriate, misleading, or abusive reviews without notice.</p>
        </div>

        <div className="simple-section">
          <h2>9. Communications & Notifications</h2>
          <p>By using the App, you consent to receive system notifications related to account activity, transactions, service updates, and security alerts.</p>
        </div>

        <div className="simple-section">
          <h2>10. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, Home Manager is not responsible for the conduct, performance, or safety of any user. Our total liability shall not exceed the amount paid by you to us in the past 6 months.</p>
        </div>

        <div className="simple-section">
          <h2>11. Account Termination</h2>
          <p>We reserve the right to suspend or terminate accounts that violate these Terms or applicable laws. You may terminate your account at any time through App settings or by contacting us.</p>
        </div>

        <div className="simple-section">
          <h2>12. Dispute Resolution</h2>
          <p>Disputes shall be handled by competent courts within Kampala, Uganda, governed by Ugandan law.</p>
        </div>

        <div className="simple-section">
          <h2>13. Modifications</h2>
          <p>We reserve the right to modify these Terms at any time. Changes will be posted in the App with an updated "Last Updated" date.</p>
        </div>

        <div className="simple-section contact-section">
          <h2>14. Contact Information & Support</h2>
          <p><strong>Company Name:</strong> Xigen Technologies</p>
          <p><strong>Registered Address:</strong> Plot 4, Colline House, Pilkington Road, Kampala, Uganda</p>
          <p><strong>Support Email:</strong> <a href="mailto:info@xigentechnologies.com">info@xigentechnologies.com</a></p>
          <p><strong>Website:</strong> <a href="https://www.xigentechnologies.com" target="_blank" rel="noopener noreferrer">www.xigentechnologies.com</a></p>
        </div>
      </div>

      {/* Footer */}
      <div className="simple-footer">
        <p>© 2026 Home Manager by Xigen Technologies. All rights reserved.</p>
        <div className="simple-footer-links">
          <Link to="/">Home</Link>
          <Link to="/privacy">Privacy Policy</Link>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;